// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bic_jk","CommentListPlaceholder--Legacy":"ih_b bic_rc bic_wq"};